import React from 'react';
import dynamic from 'next/dynamic';
import style from './index.module.scss';

const FeedbackSwiper = dynamic(() => import('./components/FeedbackSwiper'), { ssr: false });
export default function FeedbackOverview() {
  return (
    <div className={style.feedbackOverview}>
      <div className={style.title}>
        <h4 className={style.titleText}>This is what users are saying about RoboNeo</h4>
        <h2 className={style.titleDescription}>
          They Love RoboNeo,
          <span className={style.titleDescriptionHighlight}>you will too</span>
        </h2>
      </div>
      <FeedbackSwiper />
    </div>
  );
}
